import { Pipe, PipeTransform } from '@angular/core'
import { AuthService } from '@tv3/services/auth.service'
import { User } from '@tokeet-frontend/tv3-platform'
import * as lodash from 'lodash'

@Pipe({
  name: 'UserAccess',
})
export class UserAccessPipe implements PipeTransform {
  constructor(private auth: AuthService) {}

  transform(app: keyof User['settings']): boolean {
    const settings = this.auth.user?.settings || {}
    return lodash.has(settings, app) ? !!settings[app] : this.isDefaultTrue(app)
  }

  isDefaultTrue(app: keyof User['settings']) {
    return ['margins'].includes(app)
  }
}
